import type { UiSettingsContext_QuotationEmitters } from '../fragments/quotation-emitters.fragment';

// Several emitters give no colour: the theme cannot pick one of them.
export const quotationEmitterColorOf = ({
  quotationEmitterActors,
}: Readonly<UiSettingsContext_QuotationEmitters>): string | undefined => {
  const [emitter, ...otherEmitters] = quotationEmitterActors;

  return otherEmitters.length ? undefined : emitter?.thirdParty.color;
};
